import { api } from "../http";
import {
  ApiResponse,
  StudentByMobileResponse,
  StudentPaymentRequest,
  StudentRegistrationData,
} from "../types";

export const getStudentByMobile = async (
  mobileNumber: string
): Promise<ApiResponse<StudentByMobileResponse>> => {
  const response = await api.get<ApiResponse<StudentByMobileResponse>>(
    `/Student/GetStudentByMobile?mobileNumber=${encodeURIComponent(mobileNumber)}`
  );
  return response.data;
};

export const saveStudentPayment = async (
  studentPaymentRequest: StudentPaymentRequest
): Promise<ApiResponse<string>> => {
  const response = await api.post<ApiResponse<string>>(
    "/Student/SavePayment",
    studentPaymentRequest
  );
  return response.data;
};

export const registerStudent = async (
  student: StudentRegistrationData
): Promise<ApiResponse<string>> => {
  const form = new FormData();
  form.append("FirstName", student.firstName);
  form.append("LastName", student.lastName);
  form.append("EmailId", student.emailId);
  form.append("AadharNumber", student.aadharNumber.replace(/\s/g, ""));
  form.append("OptionalIdentification", student.optionalIdentification ?? "");
  form.append("MobileNumber", student.mobileNumber);
  form.append("AlternateNumber", student.alternateNumber ?? "");
  form.append("GuardianName", student.guardianName);
  form.append("GuardianMobileNumber", student.guardianMobileNumber);
  form.append("GenderCode", student.genderCode);
  form.append("Address", student.address);
  form.append("JoiningDate", student.joiningDate);
  if (student.amount) {
    form.append("Amount", student.amount);
  }
  if (student.validityFrom) {
    form.append("ValidityFrom", student.validityFrom);
  }
  if (student.validityTo) {
    form.append("ValidityTo", student.validityTo);
  }

  if (student.photo) {
    form.append("Photo", student.photo);
  }

  const response = await api.post<ApiResponse<string>>(
    "/Student/StudentRegistration",
    form
  );
  return response.data;
};

export const getStudentValidation = async (
  field: string,
  value: string
): Promise<ApiResponse<number>> => {
  const response = await api.get<ApiResponse<number>>(
    `/Student/Validation?field=${encodeURIComponent(field)}&value=${encodeURIComponent(value)}`
  );
  return response.data;
};

export const isFieldAlreadyRegistered = async (
  field: string,
  value: string
): Promise<boolean> => {
  const res = await getStudentValidation(field, value);
  return (res.data ?? 0) > 0;
};
